import React from 'react';
import { Skeleton, SkeletonPill, SkeletonBar } from '../../util/skeleton/Skeleton'; // adjust path
// uses skeleton.css from your library

export const SkeletonWalletCard = () => (
  <div className="card shadow-sm border-0">
    <div className="card-body d-flex flex-column">
      {/* Header */}
      <div className="d-flex align-items-start">
        {/* bank icon */}
        <Skeleton w={48} h={48} className="mr-3" style={{ borderRadius: 8 }} />

        <div className="flex-grow-1">
          <div className="d-flex align-items-center">
            <Skeleton w={180} h={18} className="mr-2" />
            <Skeleton w={120} h={12} />
          </div>
          <Skeleton w={140} h={12} style={{ marginTop: 6 }} />
        </div>

        {/* status + menu */}
        <div className="d-flex align-items-start ml-2">
          <SkeletonPill w={110} h={22} className="mr-2" />
          <Skeleton w={34} h={31} style={{ borderRadius: 8 }} />
        </div>
      </div>

      {/* Balances */}
      <div className="mt-3 d-flex align-items-center justify-content-between">
        <div style={{ minWidth: 220 }}>
          <Skeleton w={70} h={10} />
          <Skeleton w={220} h={22} style={{ marginTop: 6 }} />
        </div>
        <div className="text-right" style={{ minWidth: 220 }}>
          <Skeleton w={70} h={10} style={{ marginLeft: 'auto' }} />
          <Skeleton w={180} h={18} style={{ marginTop: 6, marginLeft: 'auto' }} />
        </div>
      </div>

      {/* Reconciliation bar */}
      <div className="mt-3">
        <div className="d-flex justify-content-between mb-2">
          <Skeleton w={100} h={10} />
          <Skeleton w={36} h={10} />
        </div>
        <SkeletonBar h={8} />
      </div>

      {/* Actions */}
      <div className="mt-auto pt-3 d-flex justify-content-between">
        <SkeletonPill w={140} h={31} />
        <div className="d-flex">
          <SkeletonPill w={160} h={31} className="mr-2" />
          <SkeletonPill w={120} h={31} />
        </div>
      </div>
    </div>
  </div>
);

